module.exports = __webpack_public_path__ + "img/record-header.b2e0de19.png";